export const Storage = {
  userKey: 'userKey',
  platform: 'platform',
  comefrom: 'comefrom',
  downloadPlatform: 'downloadPlatform',
}
